module.exports = __webpack_public_path__ + "static/media/bg-store.d9fd9981.png";